










import { Component, Mixins } from 'vue-property-decorator';
import UserMixin from '@/mixins/UserMixin';
import SupplierProfile from '@/views/SupplierProfile.vue';

@Component({
  components: {
    SupplierProfile,
  },
})
export default class Profile extends Mixins(UserMixin) {
  get profileComponent() {
    if (this.isSupplier) {
      return 'supplier-profile';
    }
    return null;
  }
}
